<template>
  <div class="main-menu-wrapper" :class="{ active: isActive }">
    <div class="menu-header">
      <router-link to="/home/" class="menu-logo">
        <img
          src="@/assets/logo/sapta.png"
          class="img-fluid header-logo-img"
          alt="Sapta LMS"
        />
      </router-link>
      <a
        id="menu_close"
        class="menu-close"
        href="javascript:void(0);"
        role="button"
        aria-label="Close menu"
        @click="closeSidebar"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
      </a>
    </div>

    <ul class="main-nav" :class="{ active: isActive }">
      <template v-for="item in HeaderData" :key="item.tittle">
        <li
          class="has-submenu megamenu"
          @mouseenter="activateMenu"
          :class="{ active: isActiveRoute(item.active_link) }"
          @mouseleave="deactivateMenu"
          v-if="isVisibleSeparate(item)"
        >
          <router-link
            :to="item.route || item.active_link"
            @click="closeSidebar"
          >
            {{ item.tittle }}
          </router-link>
        </li>
        <li
          v-else-if="isVisible(item)"
          class="has-submenu"
          :class="{
            active:
              isActiveRoute(item.active_link) ||
              isActiveRoute(item.active_link1) ||
              isActiveRoute(item.active_link2) ||
              isActiveRoute(item.active_link3),
          }"
        >
          <a href="javascript:void(0);" @click="toggleTab(item)">
            {{ item.tittle }}
            <i class="fas fa-chevron-down" aria-hidden="true"></i>
          </a>
          <ul class="submenu" :class="{ 'd-block': item.showAsTab }">
            <template v-for="menuItem in item.menu" :key="menuItem.menuValue">
              <li
                v-if="menuItem.hasSubRoute === false && canAccess(menuItem)"
                :class="{ active: isActiveRoute(menuItem.active_link) }"
              >
                <router-link
                  :to="{ path: menuItem.route }"
                  @click="closeSidebar"
                  >{{ menuItem.menuValue }}</router-link
                >
              </li>
              <li
                v-else-if="menuItem.hasSubRoute === true"
                class="has-submenu"
                :class="{ active: isActiveRoute(menuItem.active_link) }"
              >
                <a href="javascript:void(0);" @click="toggleTab(menuItem)">{{
                  menuItem.menuValue
                }}</a>
                <ul class="submenu" :class="{ 'd-block': menuItem.showAsTab }">
                  <template
                    v-for="subMenu in menuItem.subMenus"
                    :key="subMenu.menuValue"
                  >
                    <li
                      v-if="subMenu.hasSubRoute === false"
                      :class="{ active: isActiveRoute(subMenu.active_link) }"
                    >
                      <router-link
                        :to="{ path: subMenu.route }"
                        @click="closeSidebar"
                        >{{ subMenu.menuValue }}</router-link
                      >
                    </li>
                    <li
                      class="has-submenu"
                      v-if="subMenu.hasSubRoute === true"
                      :class="{ active: isActiveRoute(subMenu.active_link) }"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="toggleTab(subMenu)"
                        >{{ subMenu.menuValue }}</a
                      >
                      <ul
                        class="submenu"
                        :class="{ 'd-block': subMenu.showAsTab }"
                      >
                        <li
                          v-for="subMenuItems in subMenu.subMenusTwo"
                          :key="subMenuItems.menuValue"
                          :class="{
                            active: isActiveRoute(subMenuItems.active_link),
                          }"
                        >
                          <router-link
                            :to="{ path: subMenuItems.route }"
                            @click="closeSidebar"
                            >{{ subMenuItems.menuValue }}</router-link
                          >
                        </li>
                      </ul>
                    </li>
                  </template>
                </ul>
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>

    <div class="menu-login">
      <router-link
        to="/login"
        v-if="!authStore.currentUser"
        class="btn btn-primary w-100 mb-2"
        @click="closeSidebar"
      >
        <i class="isax isax-user me-2" aria-hidden="true"></i>Sign In
      </router-link>
      <template v-else>
        <router-link
          :to="profileRoute"
          class="btn btn-light w-100 mb-2"
          @click="closeSidebar"
        >
          <i class="isax isax-security-user me-2" aria-hidden="true"></i>My
          Profile
        </router-link>
        <button
          type="button"
          class="btn btn-outline-danger w-100"
          @click="handleLogout"
        >
          <i class="isax isax-logout me-2" aria-hidden="true"></i>Logout
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import HeaderData from "@/assets/json/header-menu.json";
import { useAuthStore } from "@/stores/auth-store";

export default {
  data() {
    return {
      HeaderData: HeaderData,
      route_array: [],
      openDropdownIndex: null,
      isDropdownOpen: false,
      isDropdownOpen1: null,
      isSidebarOpen: false,
    };
  },
  methods: {
    openSubMenu() {
      this.isDropdownOpen = !this.isDropdownOpen;
      this.openDropdownIndex = null;
    },
    openSubMenu1(index) {
      this.isDropdownOpen1 = this.isDropdownOpen1 === index ? null : index;
    },
    toggleSubMenu(index) {
      this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
      this.isDropdownOpen = false;
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.documentElement.classList.remove("menu-opened");
    },
    toggleTab(item) {
      item.showAsTab = !item.showAsTab;
    },
    handleLogout() {
      this.authStore.logout();
      this.closeSidebar();
      this.router.push("/login");
    },
  },
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const router = useRouter();
    const isActive = ref(false);

    const activateMenu = () => {
      isActive.value = true;
    };

    const deactivateMenu = () => {
      isActive.value = false;
    };

    const isActiveRoute = (activeLink) => {
      return route.path.includes(activeLink);
    };
    const canAccess = (item) => {
      if (!item.allowedRoles) return true;
      const userRole = authStore.role;
      // Guest (belum login): tampilkan item bertanda guest / katalog publik
      if (!authStore.currentUser || !userRole) {
        return item.allowedRoles.includes("guest");
      }
      return item.allowedRoles.includes(userRole);
    };
    const isVisibleSeparate = (item) => {
      const isSeparate =
        item.separateRoute === true || item.separateRoute === "true";
      return isSeparate && canAccess(item);
    };
    const isVisible = (item) => {
      const isHome = item.separateRoute === false;
      const isInstructors = item.tittle === "Instructors";
      const isStudent = item.tittle === "Student";

      return (isHome || isInstructors || isStudent) && canAccess(item);
    };
    const profileRoute = computed(() => {
      if (authStore.role === "principal") return "/principal/profile";
      if (authStore.role === "instructor" || authStore.role === "teacher") {
        return "/instructor/instructor-profile";
      }
      return "/students/student-profile";
    });
    return {
      isActive,
      activateMenu,
      deactivateMenu,
      route,
      router,
      isActiveRoute,
      authStore,
      canAccess,
      isVisible,
      isVisibleSeparate,
      profileRoute,
    };
  },
};
</script>
<style scoped>
.header-logo-img {
  max-width: 140px;
  width: auto;
  height: auto;
  max-height: 40px;
  object-fit: contain;
}
@media (max-width: 991.98px) {
  .header-logo-img {
    max-width: 120px;
    max-height: 36px;
  }
}
</style>
